import { html, View } from 'rune-ts';
import klass from './Collaboration.module.scss';
import { CollaborationController } from './CollaborationController';

export interface CollaborationBodyData {
  collaborationController: CollaborationController;
}

export class CollaborationBodyView extends View<CollaborationBodyData> {
  private _controller = this.data.collaborationController;

  override template() {
    return html`
      <div class="${klass.collaboration}">
        <!--   안내 문구     -->
        ${this._controller.makeNotificationHtml()}

        <!--   크리에이터 명   -->
        ${this._controller.creatorFormRow}

        <!--   제안 종류  -->
        ${this._controller.collaborationTypeFormRow}

        <!--   협업 카테고리   -->
        ${this._controller.collaborationFormRow}

        <!--   협업 카테고리 직접 입력    -->
        ${this._controller.categoryEtcInputView}

        <!--   제안 내용   -->
        ${this._controller.proposalFormRow}

        <!--   브랜드명   -->
        ${this._controller.brandNameFormRow}

        <!--   자사몰 홈페이지 URL   -->
        ${this._controller.brandUrlFormRow}

        <!--   담당자 성함   -->
        ${this._controller.managerNameFormRow}

        <!--   담당자 연락처   -->
        ${this._controller.managerTelFormRow}

        <!--   담당자 이메일   -->
        ${this._controller.managerEmailFormRow}

        <!--   로딩 뷰    -->
        ${this._controller.Loading}
      </div>
    `;
  }
}
